module.exports = __webpack_public_path__ + "img/text2.a9784671.png";